import { CLIENT_LIST_NAME } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case CLIENT_LIST_NAME.LOAD:
      return {
        ...state,
        loading: true,
      };
    case CLIENT_LIST_NAME.SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case CLIENT_LIST_NAME.FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}
